import Section from "../../common/Section/Section"
import IndustryInfoSection from "./IndustryInfoSection"
import IndustryCaseStudySection from "./IndustryCaseStudySection"
import ropeAccessMain from "../../../assets/img/industries/rope-access/rope_access_main.webp"
import ropeAccessCaseStudy from "../../../assets/img/industries/rope-access/rope_access_case_study.jpg"


export default function RopeAccess() {
 const caseStudyInfo = {
  title: "Rope Access Case Study", description: (<>
   <p>equi-track’s origins trace back to 2002, when our founder worked with Asset Management Pty, a rope access company in Australia supporting technicians across offshore and mining contracts. As the company grew, managing equipment and ensuring compliance with stringent safety regulations became a critical challenge—one that demanded digitisation to prevent errors and safeguard technicians who depended on reliable, safe gear. </p>
   <p>This need led to the creation of equi-track, which has since evolved through close collaboration with inspection and rope access companies. Between 2020 and 2024, equi-track was completely rebuilt using robust, modern cloud technologies, while retaining and enhancing the features essential for fast-paced rope access operations. </p>
  </>),
  img: ropeAccessCaseStudy
 }

 const industryInfo = {
  description: (<>
   <ul className="list-unstyled">
    <li className="py-1 py-lg-3"><strong>Efficient Kit Bag Management:</strong> Easily assemble and disassemble kit bags with equi-track’s intuitive features—build complete offshore kits, swap out items on the go, and maintain full traceability throughout each project.</li>
    <li className="py-1 py-lg-3"><strong>Safety-Critical Alerts: </strong> Record maintenance tasks and receive automated alerts for renewals or inspections, helping you stay compliant and safe.</li>
    <li className="py-1 py-lg-3"><strong>Parts & Consumables Control:</strong> Maintain full stock control of parts and consumables, with the flexibility to add or remove items as needed for every job.</li>
    <li className="py-1 py-lg-3"><strong>End-to-End Item Tracking: </strong> Always know the journey of each kit item—who has it, where it is, when it was used, and the associated costs.</li>
   </ul>
  </>),
  img: ropeAccessMain
 }

 return (
  <Section title="equi-track for  Rope Access" isIndustryPage>
   <IndustryInfoSection industryInfo={industryInfo} />
   <IndustryCaseStudySection caseStudyInfo={caseStudyInfo} />
  </Section>
 )
}